import { useEffect } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { Funnel } from "@b2bportal/core-types";
import { clearOfferFunnelEntrySource } from "./offerFunnelEntrySource";

/**
 * Returning to the hotel homepage other than via the offer banner starts a
 * fresh search, so drop any offer entry source left from a prior offer entry.
 */
export const useClearOfferFunnelEntrySourceOnLodgingReturn = (
  funnel: Funnel
) => {
  const location = useLocation();

  useEffect(() => {
    if (funnel !== Funnel.Lodging) return;
    const fromOfferBanner = (
      location.state as { fromOfferBanner?: boolean } | null
    )?.fromOfferBanner;
    if (!fromOfferBanner) {
      clearOfferFunnelEntrySource();
    }
  }, [funnel, location.state]);
};
